/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import { EnqueteIndexPagePaginationFragmentDoc } from './EnqueteIndexPagePagination.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type EnquetesInput = {
  limit: number;
  offset: number;
};

export type EnqueteIndexPageQueryVariables = Exact<{
  input: Types.EnquetesInput;
}>;


export type EnqueteIndexPageQuery = { enquetes: { enquetes: Array<{ guid: string, title: string }>, paginationInfo: { limit: number, offset: number, totalCount: number } } };


export const EnqueteIndexPageDocument = gql`
    query EnqueteIndexPage($input: EnquetesInput!) {
  enquetes(input: $input) {
    enquetes {
      guid
      title
    }
    paginationInfo {
      ...EnqueteIndexPagePagination
    }
  }
}
    ${EnqueteIndexPagePaginationFragmentDoc}`;

/**
 * __useEnqueteIndexPageQuery__
 *
 * To run a query within a Vue component, call `useEnqueteIndexPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnqueteIndexPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useEnqueteIndexPageQuery({
 *   input: // value for 'input'
 * });
 */
export function useEnqueteIndexPageQuery(variables: EnqueteIndexPageQueryVariables | VueCompositionApi.Ref<EnqueteIndexPageQueryVariables> | ReactiveFunction<EnqueteIndexPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<EnqueteIndexPageQuery, EnqueteIndexPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EnqueteIndexPageQuery, EnqueteIndexPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EnqueteIndexPageQuery, EnqueteIndexPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<EnqueteIndexPageQuery, EnqueteIndexPageQueryVariables>(EnqueteIndexPageDocument, variables, options);
}
export function useEnqueteIndexPageLazyQuery(variables?: EnqueteIndexPageQueryVariables | VueCompositionApi.Ref<EnqueteIndexPageQueryVariables> | ReactiveFunction<EnqueteIndexPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<EnqueteIndexPageQuery, EnqueteIndexPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EnqueteIndexPageQuery, EnqueteIndexPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EnqueteIndexPageQuery, EnqueteIndexPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<EnqueteIndexPageQuery, EnqueteIndexPageQueryVariables>(EnqueteIndexPageDocument, variables, options);
}
export type EnqueteIndexPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<EnqueteIndexPageQuery, EnqueteIndexPageQueryVariables>;